import { composeIO } from 'react-compose-io'
import { controleComissaoPedidoClassificacaoIO } from './ControleComissaoPedidoClassificacao.IO'
import { ControleComissaoPedidoClassificacaoView } from './ControleComissaoPedidoClassificacao.View'

export const ControleComissaoPedidoClassificacao = composeIO(ControleComissaoPedidoClassificacaoView, controleComissaoPedidoClassificacaoIO)
